<template>
  <div class="table-checkbox">
    <input
      :id="_uid"
      type="checkbox"
      :disabled="disabled"
      :class="{'checked': localChecked}"
      @click.prevent.stop="$emit('click')"
    >
    <label :for="_uid">
      <slot></slot>
    </label>
  </div>
</template>
<script>
export default {
  props: {
    checked: Boolean,
    disabled: Boolean,
  },
  data() {
    return {
      localChecked: false
    }
  },
  created() {
    this.localChecked = this.checked || false
  },
  methods: {
  },
  watch: {
    checked: function(val){
      this.localChecked = val
    }
  }
}
</script>